import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { validarIdentificacionNoRepetidos } from "app/logic/cliente";
import { IdentificacionComponent } from "app/features/componentes/cliente/identificacion";
import { ChoferZonaExtendidaList } from "./zonasextendidas/list";

const resource = resources.UsuarioZE;
type Entity = models.ChoferZE;
import { obtenerComponenteDireccionColonia } from "app/features/componentes/direccioncolonia";
import { required } from "kea-react/dist/validation";
export const DireccionChoferComponent = obtenerComponenteDireccionColonia<Entity>("IdColonia", "Direccion", "Dirección");

export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}


function validar(x: Entity, tipoPersona: models.TipoPersona | null) {
    const datosRep = { idChoferZE: x.IdRegistro };
    const rules: validation.Rules<Entity> = {
        Nombre: validation.required,
        IdVehiculoZE: validation.required,
        ZonasExtendidas: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un ChoferZE
*/
export class ChoferZEEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    tipoPersona = (props: Props) => props.value.Identificacion!.TipoPersona;

    errors = createSelectorRx(this.value, this.tipoPersona, validar);
    hasError = createSelectorRx(this.errors, err => validation.hasError(err));
    getField = formfields(() => this.props, () => this.errors(this.props));
    datosRep = createSelectorRx(this.value, x => ({ idChoferZE: x.IdRegistro }));

    get rules(): validation.Rules<Entity> {
        return {
            Nombre: validation.required,
            IdVehiculoZE: validation.required,
        };
    }

    onGuardar = async () => {
        var ccccc = await resource.GuardarChoferZE( this.props.value );
        if (ccccc != null ) {
            //location.reload();    
            this.props.value.IdRegistro = ccccc.IdRegistro;
            this.props.onClose(true);
        }
        //this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        var stored = JSON.parse(localStorage['myKeyIdUsuarioZE']);
        const value = this.props.value;
        const onChange = this.props.onChange;
        const getField = this.getField;
        const Text = getField(kea.Text);
        const VehiculoZE2 = getField(selectores.VehiculoZE2(stored));
        const Identificacion = getField(IdentificacionComponent);
        const ZonasExtendidas = getField(ChoferZonaExtendidaList);
        const hasError = this.hasError(this.props);

        const CpSatMunicipioSelector = getField(selectores.CpSatMunicipioSelector);
        const CpSatLocalidadSelector = getField(selectores.CpSatLocalidadSelector);
        const CpSatColoniaSelector = getField(selectores.CpSatColoniaSelector);
        
        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Editar Chofer"
            >
                {kea.autogrid(6, [
                    <Text field="Nombre" />,
                    //<VehiculoZE field="IdVehiculoZE" label="Vehículo asignado" />
                    <VehiculoZE2 field="IdVehiculoZE" label="Vehículo asignado" />,
                    <Identificacion field="Identificacion" />,
                    <Text field="NumeroLicencia" label="Numero de licencia" />,

                ])}
                {kea.autogrid(4, [
                    <Text field="DireccionCalle" label="Calle" />,
                    <Text field="DireccionNumExt" label="Numero exterior" />,
                    <Text field="DireccionNumInt" label="Numero interior" />,

                    <CpSatMunicipioSelector field="IdCpSatMunicipio" label="Municipio Sat" />,
                    <CpSatLocalidadSelector field="IdCpSatLocalidad" label="Localidad Sat" />,
                    <CpSatColoniaSelector field="IdCpSatColonia" label="Colonia Sat" />,
                ])}
                <ZonasExtendidas field="ZonasExtendidas" idChofer={value.IdRegistro} />
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/usuariosze/edit/componentes/choferes/edit.tsx